export const OurPurchaseProcess = () => {
  const steps = [
    {
      number: '01',
      title: 'Initial Contact',
      description: 'Reach out to us with basic information about your mid-rise property. We respond within 24 hours.',
      timeline: 'Day 1'
    },
    {
      number: '02',
      title: 'Property Review',
      description: 'We review your rent roll, financials, and property details. No need for extensive preparation.',
      timeline: 'Days 2-5'
    },
    {
      number: '03',
      title: 'Property Visit',
      description: 'We schedule a convenient time to tour the property and assess its condition and potential.',
      timeline: 'Days 5-10'
    },
    {
      number: '04',
      title: 'Cash Offer',
      description: 'We present a fair, no-obligation cash offer based on current market conditions and property performance.',
      timeline: 'Days 10-14'
    },
    {
      number: '05',
      title: 'Due Diligence',
      description: 'We conduct our due diligence efficiently, minimizing disruption to your operations and tenants.',
      timeline: 'Days 15-30'
    },
    {
      number: '06',
      title: 'Closing',
      description: 'We close on your timeline, typically within 30-45 days. You receive your funds at closing.',
      timeline: 'Days 30-45'
    }
  ];

  return (
    <section id="our-process" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Our Simple Purchase Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We've streamlined the acquisition process to make selling your mid-rise apartment building as easy and stress-free as possible.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 relative">
              <div className="text-6xl font-bold text-teal-500/20 absolute top-4 right-4">
                {step.number}
              </div>
              <div className="relative z-10">
                <div className="inline-block bg-teal-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-4">
                  {step.timeline}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/b3399a0596a967b9bc3ea5cd502283db.jpg"
                  alt="Closing Process"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">Why Our Process Works</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Fast Timeline</h4>
                    <p className="text-gray-600">We can close in 30-45 days, compared to 90-180 days for traditional sales.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Certainty of Close</h4>
                    <p className="text-gray-600">We're direct buyers with capital ready—no financing contingencies or deal failures.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-hand-heart-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Minimal Hassle</h4>
                    <p className="text-gray-600">No repairs, no staging, no showings to multiple buyers. We buy as-is.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-user-heart-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">Confidential Process</h4>
                    <p className="text-gray-600">We respect your privacy and work discreetly to protect tenant relationships.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};